<template>
    <div v-if="item !== null">
        <!-- {{ videoUrl }}/ {{ item.linkUrl }} -->
        <div class="col-xs-12" style="background:black;padding-left:0px;padding-right:0px;">
            <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" :src="videoUrl" allowfullscreen></iframe>
            </div>
        </div>

        <div class="col-xs-12">
            <div class="col-xs-12 col-sm-12 col-md-4" v-if="item.linkImg !== null" style="text-align:center;">
                <img v-if="item.linkImg !== null" style="display:inline-block;max-width:60px;border-radius:10px;"
                    class="agx-post-thumb" :src="item.imgThumb" :title="item.linkTitle">
            </div>

            <div class="col-xs-12 col-sm-12" :class="{ 'col-md-6': item.linkImg !== null }" style="">
                <div style="font-weight:bold;text-align:center;">{{ item.linkTitle }}</div>
            </div>
        </div>

        <div class="col-xs-12 col-sm-12">
            <div style="white-space:pre-line;text-align:center;">{{ item.linkText }}</div>
        </div>
    </div>
</template>
<script>

export default {
    components: {

    },
    props: {
        "item": { type: Object, default: null }
    },
    data: function () {
        return {

        }
    },
    computed: {
        videoUrl: function () {
            return 'https://www.youtube.com/embed/' + this.getVideoId();
        }
    },
    methods: {
        getVideoId: function () {
            try {
                const parsedUrl = new URL(this.item.linkUrl);
                return parsedUrl.searchParams.get('v');
            } catch (error) {
                return null; // Invalid URL format
            }

            // const regex = /[?&]v=([^&]+)/;
            // const match = url.match(regex);
            // return match ? match[1] : null; // Return the video ID or null if not found

        }
    },
    mounted: function () {

    }
}
</script>